export const getSaleReturnList = state => {
  return state.saleReturnList
}

export const getSaleReturnInfo = state => {
  return state.saleReturnInfo
}

export const getUnClosedSaleReturnCount = state => {
  return state.unClosedSaleReturnCount
}

export const getUnPaidSaleReturnCount = state => {
  return state.unPaidSaleReturnCount
}

export const getReportUnClosedSaleReturnCount = state => {
  return state.unClosedReportSaleReturnCount
}

export const getReportUnPaidSaleReturnCount = state => {
  return state.unPaidReportSaleReturnCount
}
